// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Credit
export const getPromissoryNoteList = createAsyncThunk('appPromissory/getPromissoryNoteList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1    
   const response = await axios.post(apiLink('getPromissoryNoteList'), params)        
   return {
      params,
      data: response.data.content,
      totalPages: response.data.totalElements
   }
})
export const getPromissoryNote = createAsyncThunk('appPromissory/getPromissoryNote', async id => {
   const response = await axios.get(apiLink({name: 'getPromissoryNote', value: id}))
   return response.data
})
export const addPromissoryNote = createAsyncThunk('appPromissory/addPromissoryNote', async (data) => {
   const response = await axios.post(apiLink('addPromissoryNote'), data)
   return response.data
})
export const getPromissoryNotePeriods = createAsyncThunk('appPromissory/getPromissoryNotePeriods', async id => {
   const response = await axios.get(apiLink({name: 'getPromissoryNotePeriods', value: id}))
   return response.data
})
export const setPromissoryNoteStatusCancel = createAsyncThunk('appPromissory/setPromissoryNoteStatusCancel', async id => {
   const response = await axios.post(apiLink({name: 'changePromissoryNoteStatus', value: id}, {status: 'CANCELLED', archive: true}))
   return response.data
})
export const recalculatePromissoryNote = createAsyncThunk('appPromissory/recalculatePromissoryNote', async id => {
   const response = await axios.post(apiLink({name: 'recalculatePromissoryNote', value: id}))
   return response.data
})
export const calculatePromissoryNote = createAsyncThunk('appPromissory/calculatePromissoryNote', async id => {
   const response = await axios.post(apiLink({name: 'calculatePromissoryNote', value: id}))
   return response.data
})

// ** Payments
export const addPayment = createAsyncThunk('appPromissory/addPayment', async (data) => {
   return await axios.post(apiLink('addPayment'), data)
})
export const removePromissoryNotePayment = createAsyncThunk('appPromissory/removePromissoryNotePayment', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'PROMISSORY_NOTE'}))
   return response.data
})

// Media files
export const getMedia = createAsyncThunk('appPromissory/getMedia', async ({promissory_id, types}) => {
   const response = await axios.post(apiLink('getFiles', {typeOwner: 'PROMISSORY_NOTE'}), {
      ids: [promissory_id],
      types
   })
   return {files: response.data.files, promissory_id}
})
export const addMedia = createAsyncThunk('appPromissory/addMedia', async ({promissory_id, type, typeOwner, file}) => {
   const response = await axios({
        method: "post",
        url: apiLink({name: 'uploadFile', value: promissory_id}, {type, typeOwner}),
        data: { file },
        headers: { "Content-Type": "multipart/form-data" }
      })
   return response.data
})
export const removeMedia = createAsyncThunk('appPromissory/removeMedia', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeFile', value: id}, {typeOwner: 'PROMISSORY_NOTE'}))
   return {id, status: response.status}
})

// ** Customers list
export const getPromissoryNoteCustomers = createAsyncThunk('appPromissory/getPromissoryNoteCustomers', async () => {
   const params = {active: true, sort_list: 'first_name', sort_order: 'ASC', rows: 1000, blacklist: false}
   const response = await axios.get(apiLink('getCustomersShortList', params))
   return response.data.customers
})

// ** Mark visit
export const promissoryNotePeriodVisited = createAsyncThunk('appPromissory/promissoryNotePeriodVisited', async data => {
   const id = data.period_id
   delete data.period_id
   const response = await axios.post(apiLink({name: 'promissoryNotePeriodVisited', value: id}, data))
   return response.data
})


export const appPromissorySlice = createSlice({
  name: 'appPromissory',
  initialState: {
    data: [],
    total: 1,
    params: {},
    selectedPromissory: null,
    customers: [],
    media: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPromissoryNoteList.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
      .addCase(getPromissoryNote.fulfilled, (state, action) => {
         state.selectedCredit = action.payload
      })
      .addCase(getMedia.fulfilled, (state, action) => {
         const uniqueMedia = [...state.media, ...action.payload.files].reduce((accumulator, current) => {
            if (!accumulator.find((item) => item.file_id === current.file_id)) {
               accumulator.push(current)
            }
            return accumulator
         }, [])
         state.media = uniqueMedia.filter((item) => item.promissory_note_id === action.payload.promissory_id)
      })
      .addCase(removeMedia.fulfilled, (state, action) => {
         if (action.payload.status === 200) {
            state.media = state.media.filter(item => item.file_id !== action.payload.id)
         }
      })     
  }
})

export default appPromissorySlice.reducer
